import { POST_USER_SUCCESS } from 'stash/actions/api/user';
import { BOOTSTRAP_GET_PROFILE_SUCCESS } from 'stash/store/bootstrapActions';
import { PATCH_PROFILE_SUCCESS } from 'stash/actions/api/profile';
import { SET_PHONE_NUMBER } from 'stash/actions/phoneNumber';

const profile = (state = {}, action) => {
	switch (action.type) {
		case PATCH_PROFILE_SUCCESS:
			return action.response.user_profile;
		case SET_PHONE_NUMBER:
			return {
				...state,
				phone_number: action.phoneNumber,
			};
		case POST_USER_SUCCESS:
		case BOOTSTRAP_GET_PROFILE_SUCCESS:
			return {
				...state,
				...action.response.profile,
			};
		default:
			return state;
	}
};

export default profile;
